import React from "react";
import { useLang } from "../i18n/LanguageContext";
import { CheckCircle2, Users, Clock, DollarSign, FileText, Award, Heart } from "lucide-react";

const ICONS = [Users, Clock, DollarSign, FileText, Award, Heart];
const TEX_BG = "https://images.pexels.com/photos/6788569/pexels-photo-6788569.jpeg";

export default function WhyChooseUs() {
  const { t } = useLang();
  return (
    <section data-testid="why-section" className="relative py-24 sm:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img src={TEX_BG} alt="" className="w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-black/80" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="max-w-3xl mb-14">
          <div className="flex items-center gap-3 text-orange-500 font-mono-label text-xs uppercase tracking-[0.25em] mb-5">
            <span className="w-8 h-px bg-orange-500" /> {t.why.label}
          </div>
          <h2 className="font-display uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
            {t.why.title}
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {t.why.items.map((it, i) => {
            const Icon = ICONS[i] || CheckCircle2;
            return (
              <div
                key={i}
                data-testid={`why-item-${i}`}
                className="group relative bg-neutral-950/80 backdrop-blur border border-neutral-800 hover:border-orange-500 rounded-sm p-7 transition-all"
              >
                <div className="flex items-start gap-4">
                  <div className="w-11 h-11 grid place-items-center bg-orange-500/10 text-orange-500 rounded-sm flex-shrink-0">
                    <Icon size={20} />
                  </div>
                  <div>
                    <div className="font-display uppercase text-white text-xl leading-tight">{it.t}</div>
                    <p className="text-neutral-400 text-sm leading-relaxed mt-2">{it.d}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
